import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { imageUrl } from "../../config/Url";
import claimManagementStyles from "../../Styles/claimManagement";

const NormalClaimManagementTable = ({
    handleAllCheckedClick,
    onSaveForNormalClaim,
    onDeleteForNormalClaim,
    allChecked,
    normalClaimListData,
    handleCheckBoxClick,
    handleDateChange,
    onChangeTextField,
    onNormalClaimTypeChange,
    formErrorForDetails,
    handleAddClick,
}) => {

    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const getFilteredTableData = (tableData) => {
        return tableData.filter((currentRow) => {
            let isValid = false;
            let date =
                currentRow.date != null ? currentRow.date : "";
            let claimTypeName =
                currentRow.claimTypeName != null ? currentRow.claimTypeName : "";
            let editedClaimAmt =
                currentRow.editedClaimAmt != null ? currentRow.editedClaimAmt : "";

            if (
                date &&
                date.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            if (
                claimTypeName &&
                claimTypeName.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } if (
                editedClaimAmt &&
                editedClaimAmt.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    const onClickView = (e, row) => {
        const openUrl = row?.attachFile;
        window.open(imageUrl + openUrl, "_blank");
    }

    const getClaimTypeOptions = (team) => {
        const filteredClaimTypeOptions = (team.claimStructureDetails || []).filter(
            (item) => String(item.claimApplyHeaderId) === String(team.claimApplyHeaderId)
        );
        return filteredClaimTypeOptions.length > 0
            ? filteredClaimTypeOptions
            : (team.claimStructureDetails || []);
    };

    const getSelectedClaimId = (team, claimTypeOptions) => {
        const defaultClaimTypeObj = claimTypeOptions.find(
            (item) => item.flag == 1
        );

        const selectedClaimId = team.selectedClaimId || defaultClaimTypeObj?.id || "";

        return claimTypeOptions.some(
            (item) => String(item.id) === String(selectedClaimId)
        )
            ? selectedClaimId
            : "";  
    };

    return (
        <>
            <LandingScreenHeader
                screenTitle={""}
                showSearchBox={true}
                showTable={true}
                showFilter={false}
                showPdfDownload={false}
                showExcelDownload={false}
                onSearch={onSearchValue}
            />

            <div
                style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "500px",
                    position: "relative",
                }}
            >
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    <thead
                        style={{
                            position: "sticky",
                            top: 0,
                            background: "#03a9f4",
                            zIndex: 3,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <tr>
                            <th
                                style={{
                                    ...claimManagementStyles.tableHeadStyle,
                                    minWidth: "60px",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={allChecked}
                                    style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                        accentColor: allChecked ? "#f44336" : "#03a9f4"
                                    }}
                                    onChange={handleAllCheckedClick}
                                />
                            </th>

                            <th
                                style={{
                                    ...claimManagementStyles.tableHeadStyle,
                                    minWidth: "100px",
                                }}
                            >
                                Date
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "190px", }}>
                                Claim Type
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "130px", }}>
                                Claim Amt
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                Attachment
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "130px", }}>
                                Action
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {getFilteredTableData(normalClaimListData).map((team) => {
                            const claimTypeOptions = getClaimTypeOptions(team);
                            const selectedClaimId = getSelectedClaimId(team, claimTypeOptions);
                            
                            return (
                            <tr key={team.id}>

                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "center",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        style={{
                                            transform: "scale(1.5)",
                                            margin: "0 8px",
                                        }}
                                        checked={team.isChecked}
                                        onChange={(e) =>
                                            handleCheckBoxClick(e, team.id)
                                        }
                                    />
                                </td>

                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "center",
                                        width: "190px"
                                    }}
                                >
                                    <BasicDatePicker
                                        color="primary"
                                        name="dateForSalesTeamList"
                                        size="small"
                                        value={team.date ? dayjs(team.date, "DD-MM-YYYY") : dayjs()}
                                        disabled={false}
                                        fullWidth
                                        onChange={(newDate) => handleDateChange(newDate, team.id)}
                                    />
                                </td>

                                <td style={{
                                    ...claimManagementStyles.cellStyle,
                                    textAlign: "left",
                                    width: "490px"
                                }}>
                                    <AutoComplete
                                        key={`${team.id}-${selectedClaimId}`}
                                        name="claimTypeId"
                                        label="Claim Type"
                                        placeHolder="Select Claim Type"
                                        keyColName="id"
                                        options={claimTypeOptions}
                                        value={selectedClaimId}
                                        onChange={onNormalClaimTypeChange(team.id)}
                                        style={{ margin: 0 }}
                                        isError={false}
                                        errorText=""
                                    />
                                </td>


                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                        <input
                                            type="number"
                                            name={"editedClaimAmt"}
                                            value={team.editedClaimAmt}
                                            onChange={(e) => onChangeTextField(e, team.id)}
                                            onWheel={(e) => e.target.blur()}
                                            style={{
                                                width: "150px",
                                                padding: "4px 6px",
                                                fontSize: "14px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                textAlign: "center",
                                            }}
                                        />
                                    </div>
                                    {formErrorForDetails?.[`editedClaimAmtError${team.id}`] && (
                                        <div style={{ color: "red", fontSize: 12, textAlign: "center", marginTop: 4 }}>
                                            {formErrorForDetails[`editedClaimAmtError${team.id}`]}
                                        </div>
                                    )}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: team.attachFile !== null ? "center" : "left" }}>
                                    {team.attachFile && team.attachFile !== null ? (
                                        <MyComponentWithIconProps
                                            statusImage={VisibilityIcon}
                                            color="primary"
                                            fontSize="medium"
                                            title="View"
                                            onClick={(e) => onClickView(e, team)}
                                        />
                                    ) : ("No attachment found")}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, verticalAlign: "middle", textAlign: "center" }}>
                                        <IconButton
                                            color="primary"
                                            onClick={(e) => handleAddClick(e, team.id)}
                                            title="Add Attachement"
                                            size="small"
                                        >
                                            <AddCircleOutlineIcon />
                                        </IconButton>
                                </td>
                            </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <br />
            <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="flex-end"
                gap={2}
            >
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Delete Claim"}
                    onClick={onDeleteForNormalClaim}
                    fullWidth={false}
                />
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Submit"}
                    onClick={onSaveForNormalClaim}
                    fullWidth={false}
                />
            </Grid>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NormalClaimManagementTable);
